import React from "react";

import styled from "styled-components/macro";

import FnrDivider from "UI/FnrDivider";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import AddOnGiftsSection from "../AddOnGiftsSection";

import AmountInput from "./AmountInput";
import ApplyToPledgeCheckbox from "./ApplyToPledgeCheckbox";
import GiftDates from "./GiftDates";
import Interval from "./Interval";
import TotalAmount from "./TotalAmount";

const SDiv = styled("div")`
  margin-left: 74px; /* Align with Dollar icon */
`;

export default function AmountSection() {
  return (
    <Wrapper>
      <FnrVerticalGap>
        <FnrVerticalGap gap={4}>
          <AmountInput />
          <SDiv>
            <AddOnGiftsSection />
          </SDiv>
          <FnrDivider $color="fnGrey" />
        </FnrVerticalGap>
        <Interval />
        <GiftDates />
        <TotalAmount />
        <ApplyToPledgeCheckbox />
      </FnrVerticalGap>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  padding-bottom: 8px;
`;
